import { FormHelperText, Stack } from '@mui/material';
import { useAppSelector, useIsDesktop } from 'Hooks';
import { UseFormRegisterReturn } from 'react-hook-form/dist/types';
import { TextInput } from '../TextInput';
import { SelectInput } from '../SelectInput';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';

interface IPhoneInput {
  registerPhonePrefix: UseFormRegisterReturn<string>;
  registerPhoneNumber: UseFormRegisterReturn<string>;
  prefixErrors?: { message: string };
  numberErrors?: { message: string };
  prefixLabel: string;
  numberLabel: string;
  shrink: boolean;
  defaultPrefixId?: number;
  prefixValue: number;
  height?: string;
}

export const PhoneInput = ({
  registerPhonePrefix,
  registerPhoneNumber,
  prefixErrors,
  numberErrors,
  prefixLabel,
  numberLabel,
  shrink,
  defaultPrefixId: defaultPrefix,
  prefixValue,
  height,
}: IPhoneInput) => {
  const isDesktop = useIsDesktop();
  const generalOptions = useAppSelector(
    (generalOptions) => generalOptions.generalOptions.generalOptions
  );

  return (
    <Stack maxWidth='400px'>
      <Stack
        component='fieldset'
        flexDirection='row-reverse'
        alignItems='center'
        justifyContent='center'
        gap='16px'
        minWidth={isDesktop ? '400px' : undefined}
      >
        <SelectInput
          value={prefixValue}
          label={prefixLabel}
          options={generalOptions?.general?.phonePrefixes || []}
          register={registerPhonePrefix}
          maxWidth={isDesktop ? '110px' : '92px'}
          hideLabel={true}
          error={prefixErrors?.message !== undefined}
          noValueText={Dictionary[DICTIONARY.General].prefix}
          ariaDescribedBy={registerPhonePrefix.name}
          defaultOptionId={defaultPrefix}
          height={height}
        />
        <TextInput
          register={registerPhoneNumber}
          errors={numberErrors?.message ? { message: '' } : undefined}
          label={numberLabel}
          shrink={shrink}
          aria-describedby={registerPhoneNumber.name}
          isNumbersOnly={true}
        />
      </Stack>
      <Stack
        flexDirection='row'
        width='100%'
        alignItems='center'
        justifyContent={numberErrors?.message ? 'space-between' : 'flex-end'}
        p='0 14px'
      >
        {numberErrors?.message && (
          <FormHelperText
            id={registerPhoneNumber.name}
            role={'alert'}
            error
            sx={{ m: 0 }}
          >
            {numberErrors?.message}
          </FormHelperText>
        )}
        {prefixErrors?.message && (
          <FormHelperText
            id={registerPhonePrefix.name}
            role={'alert'}
            error
            sx={{ m: 0 }}
          >
            {prefixErrors?.message}
          </FormHelperText>
        )}
      </Stack>
    </Stack>
  );
};
